/* eslint-disable @typescript-eslint/no-explicit-any */
import AT from '../constants/action-types';
import * as R from 'ramda';

const initialState = {
  messageEntries: [],
  logEntries: [],
  logQuery: {},
  currentLogItem: null,
  cloudLogLevel: 'trace'
};

const appendAndLimit = R.compose(R.take(1000), R.concat);

export function setCurrentLogItem(payload: any) {
  return { type: AT.LOGGING_SET_CURRENT_LOG_ITEM, payload };
}

export default function logging(state = initialState, action: any = {}) {
  switch (action.type) {
    case AT.FETCH_CLOUD_LOG_LEVEL_DONE: {
      const { logLevel } = action.data;
      return { ...state, cloudLogLevel: logLevel };
    }
    case AT.WS_MESSAGE_ENTRY_ADDED: {
      const { events } = action;
      return { ...state, messageEntries: appendAndLimit(events, state.messageEntries) };
    }
    case AT.FETCH_SEARCH_LOG_DONE: {
      const { items } = action.result.data;
      return { ...state, logEntries: items };
    }
    case AT.LOGGING_SET_CURRENT_LOG_ITEM: {
      const { kind, id } = action.payload;
      let currentLogItem = null;
      if (kind === 'messageEntry') {
        const item = R.find(R.propEq(id, '_id'))(state.messageEntries);
        if (!item) {
          return state;
        }
        currentLogItem = { kind: 'messageEntry', ...item };
      }
      if (kind === 'logEntry') {
        const item = R.find(R.propEq(id, '_id'))(state.logEntries);
        if (!item) {
          return state;
        }
        currentLogItem = { kind: 'logEntry', ...item };
      }
      return { ...state, currentLogItem };
    }
    default: {
      return state;
    }
  }
}
